import { render, staticRenderFns } from "./CoursesListWidget.vue?vue&type=template&id=7a8fab24&scoped=true"
import script from "./CoursesListWidget.vue?vue&type=script&lang=js"
export * from "./CoursesListWidget.vue?vue&type=script&lang=js"
import style0 from "./CoursesListWidget.vue?vue&type=style&index=0&id=7a8fab24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8fab24",
  null
  
)

export default component.exports